<form [formGroup]="myForm">
  <mat-form-field appearance="outline">
    <mat-label>Search for ULBs</mat-label>
    <input matInput type="text" formControlName="ulbName" [matAutocomplete]="auto" #cityInput />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      @for (option of filteredUlbs(); track $index) {
      <mat-option [value]="option.name" (onSelectionChange)="onCitySelection(option)">
        <small>{{ option.name }}</small>
      </mat-option>
      } @if (noDataFound()) {
      <mat-option class="text-muted" disabled>No results found.</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>